import { ShoppingBag } from "lucide-react";
import { addToBagUrl, productUrl } from "@/data/catalog";

/** Cart permalink that degrades to the product page when Shopify reports the variant sold out. */
export const AddToBag = ({ p, className = "btn-bag", testId, children = "Add to bag", soldOutLabel = "Sold out · view product" }) => {
  if (p.available === false) {
    return (
      <a href={productUrl(p.handle)} data-testid={testId} data-sold-out="true" className={`${className} opacity-70 grayscale`}>
        {soldOutLabel}
      </a>
    );
  }
  return (
    <a href={addToBagUrl(p.variant)} data-testid={testId} data-price={p.price} data-name={p.name || p.title} className={className}>
      <ShoppingBag className={className.includes("btn-gold") ? "h-4 w-4" : "h-3.5 w-3.5"} /> {children}
    </a>
  );
};

export const SoldOutBadge = ({ p, className = "" }) =>
  p.available === false ? (
    <span data-testid={`sold-out-${p.id}`} className={`rounded-full bg-ink/85 px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.16em] text-cream backdrop-blur-md ${className}`}>
      Sold out
    </span>
  ) : null;
